import { render, staticRenderFns } from "./SurveyAnswersList.vue?vue&type=template&id=76a5506f&"
import script from "./SurveyAnswersList.vue?vue&type=script&lang=ts&"
export * from "./SurveyAnswersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports